module.exports = __webpack_public_path__ + "img/feature_worldwide.cc325622.png";